import type { FC } from 'react'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { RANGES } from 'src/components/composed/LoanProductCalc/constants'
import { messages } from 'src/components/composed/LoanProductCalc/messages'
import { pushGtmEventOnChangeCalculate } from '@/components/composed/LoanProductCalc/gtm-helpers'
import { SliderValueMoney, SliderValueTerm } from '@/components/ui/ReactHookFormFields'
import { getUserGtmInfo } from '@/logic/metrika/helpers'
import type { RootState } from '@/redux/interfaces'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import type { ILoanProductCalcFormProps } from './types'

const mapState = (state: RootState) => ({
  userGtmInfo: getUserGtmInfo()(state),
})

export const LoanProductCalcForm: FC<ILoanProductCalcFormProps> = props => {
  const { initialFormValues } = props

  const { control } = useFormContext()
  const { userGtmInfo } = useSelector(mapState)
  const { userRegion } = useUserRegion()
  const { isMobile } = useDeviceType()

  const settingsSliderSum = useMemo(
    () => ({
      min: RANGES.sum.minValue,
      max: RANGES.sum.maxValue,
      step: RANGES.sum.step,
      defaultValue: initialFormValues.sum,
    }),
    [initialFormValues.sum],
  )

  const settingsSliderDays = useMemo(
    () => ({ min: RANGES.days.minValue, max: RANGES.days.maxValue, step: RANGES.days.step, defaultValue: initialFormValues.days }),
    [initialFormValues.days],
  )

  return (
    <div className="loanProductCalcForm">
      <div className="loanProductCalcForm__fields">
        <SliderValueMoney
          name="sum"
          settings={settingsSliderSum}
          control={control}
          label={messages.form.size}
          pointsCount={isMobile ? 3 : 5}
          onChange={value => pushGtmEventOnChangeCalculate(userGtmInfo, userRegion.name, `${messages.gtmMessages.sum}-${value}`)}
        />

        <SliderValueTerm
          name="days"
          pointsType="days"
          settings={settingsSliderDays}
          control={control}
          label={messages.form.term}
          pointsCount={isMobile ? 3 : 5}
          onChange={value => pushGtmEventOnChangeCalculate(userGtmInfo, userRegion.name, `${messages.gtmMessages.days}-${value}`)}
        />
      </div>
    </div>
  )
}
